import BaseConnection from './pagination/BaseConnection';
import ReferenceDuplicateGroupDto from './ReferenceDuplicateGroupDto';

export default class ReferenceDuplicateGroupConnection extends BaseConnection {
  constructor(data = {}) {
    super(
      ReferenceDuplicateGroupConnection,
      ReferenceDuplicateGroupDto,
      data
    );
  }
}
